import React from 'react';
import { Box, Typography, Container, Paper, CircularProgress } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import triplogo from "../images/Wordmark.svg";
import { tokens } from "../theme/tokens";

const MaintenancePage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${tokens.surface} 0%, ${tokens.surfaceAlt} 100%)`,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={4}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: '16px',
            backgroundColor: 'white',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              // background: 'linear-gradient(90deg, #1976d2, #64b5f6)',
            },
          }}
        >
          <Box
            component="img"
            src={triplogo}
            alt="TripTrip Logo"
            sx={{
              height: '60px',
              mb: 4,
              animation: 'fadeIn 1s ease-in',
            }}
          />
          
          <ConstructionIcon
            sx={{
              fontSize: '80px',
              color: tokens.accent,
              mb: 3,
              animation: 'pulse 2s infinite',
            }}
          />
          
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              background: `linear-gradient(45deg, ${tokens.brand}, ${tokens.accent})`,
              backgroundClip: 'text',
              textFillColor: 'transparent',
              mb: 2,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Under Maintenance
          </Typography>
          
          <Typography
            variant="h6"
            sx={{
              color: tokens.text,
              mb: 3,
              fontWeight: 500,
            }}
          >
            We're currently performing scheduled maintenance
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              color: tokens.textMuted,
              maxWidth: '600px',
              mx: 'auto',
              mb: 4,
              lineHeight: 1.7,
            }}
          >
            Our team is working hard to improve your experience. We'll be back shortly with an even better service. Thank you for your patience.
          </Typography>
          
  
        </Paper>
      </Container>

      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default MaintenancePage; 